// extracted by mini-css-extract-plugin
export default {"hologramWrapper":"styles_hologramWrapper__aW3S+","header":"styles_header__Tb6G1"};